(function(){
'use strict';

scSocialButtons.$inject = ["$compile", "$parse", "$templateCache", "$location", "$timeout", "$http", "$window", "linkBigTip", "scSocialShareLinks", "scPagesService", "scSingleShareService", "scDomainsService", "$state", "accessibilityService"];
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/**
 * @kind directive
 * @name scSocialButtons
 *
 * @description
 * Outputs social share buttons
 */

function scSocialButtons($compile, $parse, $templateCache, $location, $timeout, $http, $window, linkBigTip, scSocialShareLinks, scPagesService, scSingleShareService, scDomainsService, $state, accessibilityService) {
  return {
    scope: {},

    link: function link(scope, element, attrs) {
      scope.twitterUrl = '';
      scope.mailToUrl = '';
      scope.smsUrl = '';
      scope.instagramUrl = '';

      var showQRModeTimeout = void 0;

      scope.instagramDataId = $location.url().includes('thank') && 'thankyou-share-meta_ig';

      scope.cta = $parse(attrs.callToAction)(scope);
      scope.mode = $parse(attrs.scSocialButtons)(scope);
      var isUnifiedShare = attrs.isUnifiedShare || false;

      scope.isMobile = window.matchMedia('(max-width: 768px)').matches;

      scope.modeClass = function () {
        return scope.mode + '-mode';
      };

      var template = $templateCache.get('global/directives/scSocialButtons/template');

      if (isUnifiedShare === 'true') {
        template = $templateCache.get('global/directives/scSocialButtons/share.template');
        scope.copyText = 'Copy link';
        scope.npoLogo = _.get(SC.organization, 'branding.header_image', null);

        scope.campaignName = SC.campaign.name;
      }

      var compiled = null;

      switch (scope.mode) {
        case 'tooltip':
          {
            var tooltip = linkBigTip({
              element: element,
              template: template,
              scope: scope,
              event: 'click',
              width: 140,
              scroll: false,
              bg: '#F8F8F8'
            });
            scope.open = tooltip.open;
            scope.close = tooltip.close;
            break;
          }

        case 'overlay':
          {
            scope.open = function () {
              if (scSingleShareService.isOn() != true) {
                compiled = $compile(template)(scope);
                compiled.appendTo('body').attr('tabindex', '0');

                if (!isUnifiedShare) {
                  compiled.focus();
                }

                scSingleShareService.On();

                // Unified, more prominent Share icon across all FRS pages
                if (isUnifiedShare === 'true') {
                  scope.isQrMode = false;
                  var entity = scope.getEntityType(SC);

                  scDomainsService.getSlug(entity.type, entity.id).then(function (response) {
                    if (response.data.total > 0) {
                      var domainMaskURL = response.data.data[0].domain_masking_url;
                      var slug = response.data.data[0].value;
                      scope.vanityURL = domainMaskURL + '/' + slug;
                    } else {
                      scope.vanityURL = scPagesService.getShareableUrl() || window.location.href;
                    }
                  });
                }

                if ($state.is('frs.fundraiser.index')) {
                  var modalElements = document.querySelector('#social-dropdown-menu');
                  modalElements.addEventListener(accessibilityService.CONSTANTS.KEYDOWN_EVENT, scope.handleKeyEvents(modalElements));
                }
                document.querySelector('.public-page').setAttribute('aria-hidden', 'true');
              }
            };
            scope.close = function () {
              scSingleShareService.Off();
              scope.isQrMode = false;
              document.querySelector('.public-page').removeAttribute('aria-hidden');
              element.focus();
              if (compiled) {
                compiled.remove();
              }
            };
            element.on('click', scope.open);
            scope.$on('scSocialButtons.open', scope.open);
            scope.$on('$destroy', function () {
              element.off('click', scope.open);
            });
            break;
          }

        case 'icons':
          compiled = $compile(template)(scope);
          compiled.appendTo(element);
          break;

        default:
        // do nothing
      }

      /* -------------------------------------------------------------------- *
       * Init
       * -------------------------------------------------------------------- */

      scope.previousUrl = scPagesService.getShareableUrl();

      scSocialShareLinks.getSocialData().then(function (data) {
        scope.twitterUrl = data.twitter_link;
        scope.mailToUrl = data.email_link;
        scope.smsUrl = data.sms_link;
        scope.fbShare = data.facebook_share;
        scSocialShareLinks.getInstagramLink().then(function (additionalData) {
          var combinedData = Object.assign({}, data, additionalData);

          scope.twitterUrl = combinedData.twitter_link;
          scope.mailToUrl = combinedData.email_link;
          scope.smsUrl = combinedData.sms_link;
          scope.fbShare = combinedData.facebook_share;
          scope.instagramUrl = combinedData.instagram_link;
        });
      });

      scope.getEntityType = function (SC) {
        if (SC.fundraiser) {
          scope.name = SC.fundraiser.name;
          return { type: 'fundraising-pages', id: SC.fundraiser.id, name: SC.fundraiser.name };
        } else if (SC.team) {
          scope.name = SC.team.name;
          return { type: 'fundraising-teams', id: SC.team.id, name: SC.team.name };
        } else if (SC.campaign) {
          scope.name = SC.campaign.name;
          return { type: 'campaigns', id: SC.campaign.id, name: SC.campaign.name };
        }
        return { type: 'campaigns', id: SC.campaign.id, name: SC.campaign.name };
      };

      scope.isPreview = function () {
        if ($state.is('admin.manage.campaign.step.setup') || $state.is('admin.manage.campaign.step.design.views.content-blocks')) {
          return true;
        }
        return false;
      };

      scope.setCancelButton = function ($event) {
        if ($event) {
          if ($event.keyCode === accessibilityService.CONSTANTS.ENTER_KEY || $event.keyCode === accessibilityService.CONSTANTS.SPACE_KEY) {
            this.close();
          }
        }
      };

      scope.handleKeyEvents = function (modalElements) {
        return function (event) {
          /**
          getting all the focusable elements in the modal.
          get the first and last focusable element in the modal
          */
          var focusableModalElements = modalElements.querySelectorAll(accessibilityService.CONSTANTS.ELEMENTS_TO_FOCUS);
          var firstFocusableElement = focusableModalElements[0];
          var lastFocusableElement = focusableModalElements[focusableModalElements.length - 1];
          function handleBackwardTab() {
            if (document.activeElement === firstFocusableElement) {
              event.preventDefault();
              lastFocusableElement.focus();
            }
          }
          function handleForwardTab() {
            if (document.activeElement === lastFocusableElement) {
              event.preventDefault();
              firstFocusableElement.focus();
            }
          }

          switch (event.keyCode) {
            case accessibilityService.CONSTANTS.TAB_KEY:
              // If there is only one focusable element in the modal, there is no need to handle tabbing events
              if (focusableModalElements.length === 1) {
                event.preventDefault();
                break;
              }
              if (event.shiftKey) {
                handleBackwardTab();
              } else {
                handleForwardTab();
              }
              break;
            case accessibilityService.CONSTANTS.ESC_KEY:
              scope.close();
              element.focus();
              break;
            default:
              break;
          }
        };
      };

      // Generate QR Code as Data URL
      scope.generateQrCode = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var qrUrl, result;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                qrUrl = scope.vanityURL || $location.absUrl();
                _context.next = 3;
                return $http({
                  method: 'GET',
                  url: '/frs-api/generate/qr-code',
                  params: {
                    url: qrUrl
                  }
                });

              case 3:
                result = _context.sent;


                scope.qrCodeUrl = result.data.url || null;
                scope.$apply();

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      scope.saveQr = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var entity, entityName, canvas, ctx, logoPromise, qrPromise, _ref3, _ref4, logoImage, qrImage, topY, nextY, maxW, maxH, w, h, scale, x, TEXT, MAX_W, PAD_X, PAD_Y, fontSize, textW, m, ascent, descent, textH, boxW, boxH, boxX, boxY, R, qrSize, qrX, qrY;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                entity = scope.getEntityType ? scope.getEntityType(SC) : null;
                entityName = entity && entity.name ? String(entity.name) : '';

                // Create canvas element

                canvas = document.createElement('canvas');
                ctx = canvas.getContext('2d');

                // Set canvas dimensions

                canvas.width = 400;
                canvas.height = 500;

                // Fill background with white
                ctx.fillStyle = '#ffffff';
                ctx.fillRect(0, 0, canvas.width, canvas.height);

                // Add border
                ctx.strokeStyle = '#000000';
                ctx.lineWidth = 2;
                ctx.strokeRect(10, 10, canvas.width - 20, canvas.height - 20);

                // Load both images concurrently
                logoPromise = new Promise(function (resolve) {
                  if (!scope.npoLogo) {
                    // eslint-disable-next-line no-console
                    console.warn('Logo URL is empty - using placeholder.');
                    resolve(null);
                  } else {
                    var img = new Image();
                    img.crossOrigin = 'anonymous';
                    img.decoding = 'async';

                    img.onload = function () {
                      // Offscreen taint test
                      var t = document.createElement('canvas');
                      t.width = Math.max(1, Math.min(2, img.naturalWidth || img.width || 2));
                      t.height = Math.max(1, Math.min(2, img.naturalHeight || img.height || 2));
                      var tctx = t.getContext('2d');
                      try {
                        tctx.drawImage(img, 0, 0, t.width, t.height);
                        tctx.getImageData(0, 0, 1, 1);
                        resolve(img); // safe
                      } catch (e) {
                        resolve(null); // would taint → skip on main canvas
                      }
                    };

                    img.onerror = function (evt) {
                      // eslint-disable-next-line no-console
                      console.warn('Logo failed to load; using placeholder.', {
                        url: scope.npoLogo,
                        error: evt
                      });
                      resolve(null);
                    };

                    img.src = scope.npoLogo;
                  }
                });
                qrPromise = new Promise(function (resolve) {
                  if (!scope.qrCodeUrl) {
                    // eslint-disable-next-line no-console
                    console.error('QR code URL is empty.');
                    resolve(null);
                  } else {
                    var img = new Image();
                    img.crossOrigin = 'anonymous';
                    img.decoding = 'async';

                    img.onload = function () {
                      resolve(img);
                    };
                    img.onerror = function (evt) {
                      // eslint-disable-next-line no-console
                      console.error('QR code failed to load.', { url: scope.qrCodeUrl, error: evt });
                      resolve(null);
                    };

                    img.src = scope.qrCodeUrl;
                  }
                });
                _context2.next = 15;
                return Promise.all([logoPromise, qrPromise]);

              case 15:
                _ref3 = _context2.sent;
                _ref4 = _slicedToArray(_ref3, 2);
                logoImage = _ref4[0];
                qrImage = _ref4[1];


                // Top: logo OR placeholder
                topY = 20;
                nextY = topY;


                if (logoImage) {
                  maxW = 300, maxH = 60;
                  w = logoImage.naturalWidth || logoImage.width;
                  h = logoImage.naturalHeight || logoImage.height;
                  scale = Math.min(maxW / w, maxH / h, 1);

                  w *= scale;
                  h *= scale;
                  x = (canvas.width - w) / 2;

                  ctx.drawImage(logoImage, x, topY, w, h);
                  nextY = topY + h + 30;
                } else {
                  TEXT = 'Donate now!';
                  MAX_W = 320, PAD_X = 28, PAD_Y = 16;


                  ctx.textAlign = 'center';
                  ctx.textBaseline = 'middle';
                  ctx.fillStyle = '#000';

                  fontSize = 24;
                  textW = void 0;

                  do {
                    ctx.font = 'bold ' + fontSize + 'px Arial';
                    textW = ctx.measureText(TEXT).width;
                    fontSize -= 1;
                  } while (fontSize > 14 && textW > MAX_W - PAD_X * 2);

                  m = ctx.measureText(TEXT);
                  ascent = m.actualBoundingBoxAscent || fontSize * 0.8;
                  descent = m.actualBoundingBoxDescent || fontSize * 0.4;
                  textH = ascent + descent;
                  boxW = Math.min(MAX_W, Math.ceil(textW + PAD_X * 2));
                  boxH = Math.ceil(textH + PAD_Y * 2);
                  boxX = Math.round((canvas.width - boxW) / 2);
                  boxY = topY;
                  R = Math.floor(boxH / 2);


                  ctx.beginPath();
                  ctx.moveTo(boxX + R, boxY);
                  ctx.arcTo(boxX + boxW, boxY, boxX + boxW, boxY + boxH, R);
                  ctx.arcTo(boxX + boxW, boxY + boxH, boxX, boxY + boxH, R);
                  ctx.arcTo(boxX, boxY + boxH, boxX, boxY, R);
                  ctx.arcTo(boxX, boxY, boxX + boxW, boxY, R);
                  ctx.closePath();
                  ctx.fillStyle = '#cef3bd';
                  ctx.fill();

                  ctx.fillStyle = '#000';
                  ctx.fillText(TEXT, boxX + boxW / 2, boxY + boxH / 2);

                  nextY = boxY + boxH + 30;
                }

                // QR block
                qrSize = 200;
                qrX = (canvas.width - qrSize) / 2;
                qrY = nextY;


                if (qrImage) {
                  ctx.drawImage(qrImage, qrX, qrY, qrSize, qrSize);
                }

                // Add text below QR code
                ctx.fillStyle = '#000';
                ctx.textAlign = 'center';
                ctx.textBaseline = 'alphabetic';
                ctx.font = '16px Arial';
                ctx.fillText('Scan to support', canvas.width / 2, qrY + qrSize + 30);

                // Add organization name
                ctx.font = 'bold 18px Arial';
                ctx.fillText(entityName, canvas.width / 2, qrY + qrSize + 60);

                // Export as PNG
                canvas.toBlob(function (blob) {
                  var url = URL.createObjectURL(blob);
                  var a = document.createElement('a');
                  a.href = url;
                  a.download = 'qr-code.png';
                  document.body.appendChild(a);
                  a.click();
                  document.body.removeChild(a);
                  URL.revokeObjectURL(url);
                }, 'image/png');

              case 34:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      scope.getRoute = function () {
        if ($state.includes('frs.fundraiser.index')) {
          return 'frs.fundraiser.index.printposter';
        }

        if ($state.includes('frs.landing.name.campaign')) {
          return 'frs.landing.name.campaign.printposter';
        }

        if ($state.includes('frs.fundraiser.dashboardindex')) {
          return 'frs.fundraiser.dashboardindex.printposter';
        }

        if ($state.includes('frs.team.index')) {
          return 'frs.team.index.printposter';
        }

        if ($state.includes('frs.team.dashboardindex')) {
          return 'frs.team.dashboardindex.printposter';
        }

        return null;
      };

      scope.openPrintPoster = function () {
        var stateParams = {
          vanityURL: scope.vanityURL || null
        };

        window.localStorage.setItem('qrCodeUrl', scope.qrCodeUrl);

        var route = scope.getRoute();

        var baseUrl = $state.href(route, stateParams);

        $window.open(baseUrl, '_blank');

        scope.close();
      };

      /* QR Mode Functions */
      scope.showQrMode = function () {
        if (showQRModeTimeout) {
          $timeout.cancel(showQRModeTimeout);
        }

        scope.generateQrCode();

        var socialIconContent = compiled.find('.social-icon-content');
        socialIconContent.removeClass('slide-in').addClass('slide-out');

        scope.isQrMode = true;
        showQRModeTimeout = $timeout(function () {
          var qrSection = compiled.find('.qr-content');
          qrSection.removeClass('slide-out').addClass('slide-in');
          compiled.find('.social-buttons_section').addClass('qr-code-mode');
        }, 50);
      };

      scope.onCopySuccess = function () {
        scope.copyText = 'Copied';
        $timeout(function () {
          scope.copyText = 'Copy link';
        }, 3000);
      };

      scope.goBack = function () {
        var qrSection = compiled.find('.qr-content');
        qrSection.removeClass('slide-in').addClass('slide-out');
        compiled.find('.social-buttons_section').removeClass('qr-code-mode');
        var socialIconContent = compiled.find('.social-icon-content');
        socialIconContent.removeClass('slide-out').addClass('slide-in');
      };
    }
  };
}

angular.module('classy').directive('scSocialButtons', scSocialButtons);
})();